import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
    exportTemplates,
    importTemplates,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      const reg = /^(?!$)\d{0,9}(?:\.\d{1,3})?$/
      if (rule.field === 'zipCode') {
        if (String(value).length > 10) {
          callback(
            new Error('Zip code must be less than or equals to 10 characters'),
          )
        } else {
          callback()
        }
      } else {
        if (!reg.test(value)) {
          callback(
            new Error('Please enter valid location factor (e.g.: 123456.1234)'),
          )
        } else if (value > 9.999) {
          callback(
            new Error(
              'Location factor should less than or equals to 9.999!',
            ),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: false,
      spinner: false,
      defaultSortedBy: 'zipCode',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      factorList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        locationFactor: undefined,
        city: undefined,
        state: undefined,
        zipCode: undefined,
        isActive: 1,
      },
      rules: {
        locationFactor: [
          {
            required: true,
            message: 'Please enter location factor',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        city: [
          { required: true, message: 'Please enter city', trigger: 'blur' },
        ],
        state: [
          { required: true, message: 'Please enter state', trigger: 'blur' },
        ],
        zipCode: [
          { required: true, message: 'Please enter zip code', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      exportClicked: false,
      uploadedFile: null,
      importClicked: false,
      importColDef: gridProperties.import.columns.locationFactor,
      loadImport: false,
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadConfig()
  },
  mounted() {
    this.$root.$on('deleteLocationFactor', this.deleteLocationFactor)
    this.$root.$on('editLocationFactor', this.getLocationFactorIndexById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '15') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.factorList = []
        this.loading = false
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editLocationFactor')
    this.$root.$off('deleteLocationFactor')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.columnDefs = gridProperties.master.columns.locationFactor
    },

    // Refresh Location Factor
    refreshLocationFactor() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.factorList = []
      this.page = 0
      this.defaultSortedBy = 'zipCode'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'zipCode',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getLocationFactor(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Location Factor
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Location Factor'
      this.form.id = null
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Location Factor
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.locationFactor.add
          let method = 'post'
          const req = {
            zipCode: this.form.zipCode,
            state: this.form.state,
            city: this.form.city,
            locationFactor: this.form.locationFactor,
          }
          if (this.form.id) {
            url = masterAPIs.locationFactor.details(this.form.id)
            method = 'patch'
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              showNotification(
                'success',
                this.form.id
                  ? 'Update Location Factor'
                  : 'Create Location Factor',
                this.form.id
                  ? 'Location Factor updated successfully!'
                  : 'Location Factor created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.factorList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.factorList = newData
              } else {
                this.getLocationFactor(this.tableParams)
              }
              this.visible = false
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load Location Factor
    getLocationFactor(params, type) {
      this.height = calculateGridHeight(
        'locationTable',
        this.count > this.pageSize,
      )
      this.loading = true
      this.loadRefresh = true
      instance
        .post(masterAPIs.locationFactor.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          city: _.get(this.filters, 'city', undefined),
          state: _.get(this.filters, 'state', undefined),
          zipCode: _.get(this.filters, 'zipCode', undefined),
          locationFactor: _.get(this.filters, 'locationFactor', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.factorList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'locationTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Location Factor By Id
    getLocationFactorIndexById(id) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(masterAPIs.locationFactor.details(id))
        .then(response => {
          this.form = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.locationFactor.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Location Factor',
            'Location Factor deleted successfully!',
          )
          this.refreshLocationFactor()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Location Factors
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected Location Factors ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              location factor
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Location Factor
    deleteLocationFactor(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this location
              factor
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    checkboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    headerCheckboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = false
      this.factorList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'zipCode'
        this.defaultSortOrder = true
      }
      this.getLocationFactor(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'locationTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.factorList = []
      this.selectedRowKeys = []
      this.getLocationFactor(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.factorList = []
      this.getLocationFactor(this.gridOptions)
    },

    // exportClicked
    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    updateTable() {
      this.importClicked = false
      this.refreshLocationFactor()
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshLocationFactor()
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.locationFactor,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.locationFactor))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getLocationFactor(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'zipCode'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'zipCode',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
